import { ReactNode } from "react";
import { Typography } from "@mui/material";
import styles from "./SetupPageHeader.module.css";
import BackgroundDecorationLeft from "../images/header-background-decoration-left.svg?react";
import BackgroundDecorationRight from "../images/header-background-decoration-right.svg?react";

export default function SetupPageHeader({
	title,
	description,
	children,
}: {
	title: ReactNode;
	description: ReactNode;
	children?: ReactNode;
}) {
	return (
		<div className={styles.header}>
			<div className={styles.leftBackgroundDecoration}>
				<BackgroundDecorationLeft />
			</div>
			<div className={styles.rightBackgroundDecoration}>
				<BackgroundDecorationRight />
			</div>
			<div className={styles.headerContent}>
				<div className={styles.textArea}>
					<Typography variant="h1" className={styles.title}>
						{title}
					</Typography>
					{description}
				</div>
				{children}
			</div>
		</div>
	);
}
